<template>
  <w-sliding-popup ref="slidingPopup" :type="popupType" title="VM 변환/복제" top="50px" width="500px" @close="close">
    <div slot="content">
      <el-row>
        <el-radio-group v-model="executeType"  @change="onChangeExecuteType">
          <el-radio v-for="item in vmConvertTypeList" :label="item.type" :key="item.type">{{item.label}}</el-radio>
        </el-radio-group>
      </el-row>
      <el-form :model="formData" ref="formRef" class="mr-t30" label-position="top" :rules="rules">
        <el-form-item label="이름" prop="vmName">
          <el-row type="flex">
            <el-input :disabled="nameInputDisabledFlag" v-model="formData.vmName" ref="nameInputField"></el-input>
            <el-button :disabled="nameInputDisabledFlag" class="mr-l5" style="float: left;" type="solid" @click="onClickDuplicateCheck">중복검사</el-button>
          </el-row>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer">
      <el-button v-show="!nameInputDisabledFlag" :disabled="!duplicateCheckFlag" type="solid" size="large" @click="onClickExecuteButton">수행</el-button>
      <el-button v-show="nameInputDisabledFlag" type="solid" size="large" @click="onClickExecuteButton">수행</el-button>
      <el-button size="large" @click="close">취소</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import VirtualCommonApi from '@/api/virtual/performance/common';
import msgUtil from '@/utils/message';

export default {
  name: 'WVirtualVmConvertPopup',
  props: {
    objInfo: {
      type: Object,
      default: () => ({}),
    },
    popupType: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      rules: {
        vmName: { required: true, trigger: 'blur', validator: this.validateVmNameCheck },
      },
      nameInputDisabledFlag: true,
      duplicateCheckFlag: false,
      validateCheckFlag: false,
      executeType: 'CONVERT_VMTOTEMP',
      formData: {
        vmName: '',
      },
      vmConvertTypeList: [
        { label: '템플릿으로 변환', type: 'CONVERT_VMTOTEMP' }, { label: '템플릿으로 배포', type: 'COPY_VMTOTEMP' }, { label: 'VM 복제', type: 'COPY_VMTOVM' },
      ],
    };
  },
  computed: {
    executeTypeName() {
      let result = '';
      if (this.executeType === 'CONVERT_VMTOTEMP') {
        result = '템플릿 변환';
      } else if (this.executeType === 'COPY_VMTOTEMP') {
        result = '템플릿 배포';
      } else if (this.executeType === 'COPY_VMTOVM') {
        result = 'VM 복제';
      }
      return result;
    },
  },
  methods: {
    open() {
      this.$refs.slidingPopup.visible = true;
    },
    close() {
      this.$refs.slidingPopup.visible = false;
      this.executeType = 'CONVERT_VMTOTEMP';
      this.nameInputDisabledFlag = true;
      this.initData();
    },
    initData() {
      this.duplicateCheckFlag = false;
      this.formData.vmName = '';
      this.$refs.formRef.resetFields();
      this.validateCheckFlag = false;
    },
    onChangeExecuteType(value) {
      if (value === 'CONVERT_VMTOTEMP') {
        this.$refs.formRef.resetFields();
        this.nameInputDisabledFlag = true;
      } else {
        this.$refs.formRef.resetFields();
        this.nameInputDisabledFlag = false;
      }
      this.initData();
    },
    onClickDuplicateCheck() {
      if (this.validateCheckFlag) {
        // 중복검사 api 호출
        VirtualCommonApi.checkVmName({ vmName: this.formData.vmName }).then((res) => {
          if (res.data.data) {
            this.duplicateCheckFlag = false;
            this.$message(msgUtil.getCustomResultMsgData('중복된 이름입니다.', false));
          } else {
            this.duplicateCheckFlag = true;
            this.$message(msgUtil.getCustomResultMsgData('사용할 수 있는 이름입니다.', true));
          }
        });
      }
    },
    onClickExecuteButton() {
      this.$nextTick(() => {
        const params = {
          objId: this.objInfo.obj.objId,
          executeType: this.executeType,
          vmName: this.nameInputDisabledFlag ? null : this.formData.vmName,
          hypervisorType: this.objInfo.hypervisorType,
        };
        // VM 변환/복제 수행
        VirtualCommonApi.executeVmConvert(params).then((res) => {
          if (res.data.success) {
            this.$message(msgUtil.getCustomResultMsgData(`${this.executeTypeName}에 성공하였습니다.`, true));
            this.close();
          }
        });
      });
    },
    // 유효성 검사
    validateVmNameCheck(rule, value, callback) {
      if ((isEmpty(value) || value === '' || value.length > 50)) {
        callback(new Error('1~50 길이의 이름을 입력해주세요.'));
        this.validateCheckFlag = false;
        this.duplicateCheckFlag = false;
      } else {
        VirtualCommonApi.getVmNameRegex().then((response) => {
          if (response.data.data) {
            const vmNameRegexStr = response.data.data;
            const vmNameRegex = new RegExp(vmNameRegexStr, 'ig');
            if (!vmNameRegex.test(this.formData.vmName)) {
              this.validateCheckFlag = false;
              this.duplicateCheckFlag = false;
              callback(new Error(`특수문자는 ${vmNameRegexStr.replace('^[', '').replace(']{1,50}$', '').replace('a-zA-Z0-9ㄱ-ㅎ가-힣', '')} 를 입력해주세요.`));
            } else {
              this.validateCheckFlag = true;
              this.duplicateCheckFlag = false;
              callback();
            }
          } else {
            this.validateCheckFlag = true;
            this.duplicateCheckFlag = false;
            callback();
          }
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/popup/components/VirtualVmConvertPopup.vue